import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import createSelectors from "./create-selector";

interface ApiKeyStoreState {
  apiKey: string | null;
  setApiKey: (key: string) => void;
  clearApiKey: () => void;
}

const useApiKeyStoreBase = create<ApiKeyStoreState>()(
  immer((set) => ({
    apiKey: null,
    setApiKey: (key: string) => set((state) => { state.apiKey = key; }),
    clearApiKey: () => set((state) => { state.apiKey = null; }),
  }))
);

const useApiKeyStore = createSelectors(useApiKeyStoreBase);

export default useApiKeyStore;
